import React from "react";
import { useTheme } from "../../theme/ThemeContext";

const SocketDisconnectedModal = ({ status, onReconnect }) => {
  const theme = useTheme();
  const connecting = status === "connecting";

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="socket-disconnected-title"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10050,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        background: "rgba(3, 7, 18, 0.72)",
        backdropFilter: "blur(6px)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 390,
          overflow: "hidden",
          borderRadius: 16,
          border: `1px solid ${theme.border}`,
          background: theme.card,
          boxShadow: "0 28px 80px rgba(0,0,0,0.55)",
        }}
      >
        <div style={{ padding: "28px 26px 24px", textAlign: "center" }}>
          <div
            style={{
              width: 56,
              height: 56,
              margin: "0 auto 16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              border: `1px solid ${theme.neg}55`,
              background: theme.negBg,
            }}
          >
            <div
              style={{
                width: 14,
                height: 14,
                borderRadius: "50%",
                background: connecting ? theme.orange : theme.neg,
                boxShadow: `0 0 16px ${connecting ? theme.orange : theme.neg}`,
              }}
            />
          </div>

          <div
            id="socket-disconnected-title"
            style={{
              marginBottom: 8,
              color: theme.text,
              fontSize: 19,
              fontWeight: 800,
            }}
          >
            Live connection lost
          </div>
          <div
            style={{
              color: theme.textM,
              fontSize: 13,
              lineHeight: 1.6,
            }}
          >
            {connecting
              ? "Reconnecting to the trading server…"
              : "Prices and trading updates are paused. Reconnect to resume the live feed."}
          </div>
        </div>

        <button
          type="button"
          onClick={onReconnect}
          disabled={connecting}
          style={{
            width: "100%",
            padding: "15px 18px",
            border: "none",
            borderTop: `1px solid ${theme.border}`,
            cursor: connecting ? "wait" : "pointer",
            background: connecting ? theme.card2 : theme.primary,
            color: connecting ? theme.textM : "#fff",
            fontSize: 13,
            fontWeight: 800,
          }}
        >
          {connecting ? "Connecting…" : "Reconnect"}
        </button>
      </div>
    </div>
  );
};

export default SocketDisconnectedModal;
